import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-create-banner',
  templateUrl: './create-banner.component.html',
  styleUrls: ['./create-banner.component.scss']
})
export class CreateBannerComponent implements OnInit {
  @Input() componentInfo: any;
  fileImg64: any;
  fileImg642: any;
  fileImg643: any;
  wrongSize: any;
  wrongSize2: any;
  wrongSize3: any;
  bannerForm: FormGroup;
  maxLength = 350;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  changeDefault(val: string) {
    let value  = (val == 'yes' ? true : false)
    this.bannerForm.get('isDefault').setValue(value);
  }

  sendData(): any {
    let pass = true
    if((this.bannerForm.value.dateFrom !== '' && this.bannerForm.value.dateTo ==='') || (this.bannerForm.value.dateFrom ==='' && this.bannerForm.value.dateTo!== '')){
      pass = false
      Swal.fire({
        title: 'Oops...',
        text: 'Debes ingresar ambas fechas o ninguna',
        icon: 'error',
        backdrop: false,
        confirmButtonText: 'Aceptar',
      });
    }else if(this.bannerForm.value.dateFrom !== '' && this.bannerForm.value.dateTo !== ''){
      if(this.convertDate(this.bannerForm.value.dateTo) < this.convertDate(this.bannerForm.value.dateFrom)){
        pass = false
        Swal.fire({
          title: 'Oops...',
          text: ' La fecha de fin debe ser mayor a la fecha de inicio',
          icon: 'error',
          backdrop: false,
          confirmButtonText: 'Aceptar',
        });
      }
    }

    if(pass){
      const dataToSend = {
        ...this.bannerForm.value,
        typeId: this.componentInfo.reference,
      };
  
      dataToSend.dateFrom = dataToSend.dateFrom ? moment(dataToSend.dateFrom).format("YYYY-MM-DD") : '';
      dataToSend.dateTo = dataToSend.dateFrom ? moment(dataToSend.dateTo).format("YYYY-MM-DD") : '';
      this.activeModal.close(dataToSend);
    }
    
  }

  private createForm(): any {
    this.bannerForm = this.fb.group({
      title: ['', Validators.required],
      img1: ['', Validators.required],
      img641: ['', Validators.required],
      img2: ['', Validators.required],
      img642: ['', Validators.required],
      img3: '',
      img643: '',
      isDefault: [false, Validators.required],
      dateFrom: '',
      dateTo: '',
      dateValid:[true, Validators.required],
    });
  }

  convertDate(date?: any): any {
    return date ? this.takeOutHMS(new Date(date)) : this.takeOutHMS(new Date());
  }

  takeOutHMS(fec: Date) {
    fec.setHours(0);
    fec.setMinutes(0);
    fec.setSeconds(0);
    fec.setMilliseconds(0)
    return fec;
  }

  getBase64(event, img, img64, tipo): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        switch (tipo) {
          case 3:
            if (image.width == 600 && image.height == 700) {
            this.wrongSize3 = null;
            this.fileImg643 = image.src;
            this.bannerForm.get(img64).setValue(this.fileImg643.split(',')[1]);
            this.bannerForm.get(img).setValue((event.target.files[0]).name);
            }else{
              this.wrongSize3 = 'Resolución de imagen no permitida (requerida: 600px x 700px)';
              return false;
            }
            break;
          case 2:
            if (image.width == 822 && image.height == 272) {
            this.wrongSize2 = null;
            this.fileImg642 = image.src;
            this.bannerForm.get(img64).setValue(this.fileImg642.split(',')[1]);
            this.bannerForm.get(img).setValue((event.target.files[0]).name);
            }else{
              this.wrongSize2 = 'Resolución de imagen no permitida (requerida: 822px x 272px)';
              return false;
            }
            break;
          default:
            if (image.width == 1440 && image.height == 120) {
            this.wrongSize = null;
            this.fileImg64 = image.src;
            this.bannerForm.get(img64).setValue(this.fileImg64.split(',')[1]);
            this.bannerForm.get(img).setValue((event.target.files[0]).name);
            }else{
              this.wrongSize = 'Resolución de imagen no permitida (requerida: 1440px x 120px)';
              return false;
            }
        }
      };
    };
    reader.onerror = (error) => {
    };
  }
}
